<div class="manage-report-views">
  <p class="manage-intro">
    Choose your default view and reorder the views you manage. Removed views are deactivated when you save.
  </p>

  <div class="view-list dashboard-default-list" *ngIf="dashboardDefaultView">
    <article class="view-row dashboard-default-row">
      <div class="order-placeholder"></div>
      <div class="view-name">
        <strong>{{ dashboardDefaultView.name }}</strong>
        <small>Configured dashboard filters</small>
      </div>
      <button type="button" class="default-view" [class.is-default]="dashboardDefaultView.isDefault"
        [disabled]="dashboardDefaultView.isDefault" (click)="setDefaultView(dashboardDefaultView)"
        [title]="dashboardDefaultView.isDefault ? 'Default view' : 'Make default'">
        <i class="fa" [class.fa-star]="dashboardDefaultView.isDefault"
          [class.fa-star-o]="!dashboardDefaultView.isDefault"></i>
        <span>{{ dashboardDefaultView.isDefault ? 'Default' : 'Make default' }}</span>
      </button>
      <div class="row-action-placeholder"></div>
    </article>
  </div>

  <ng-container *ngFor="let group of groups">
    <section class="view-group" *ngIf="groupViews(group.ownershipType).length">
      <header>
        <div>
          <strong>{{ group.label }}</strong>
          <small>Order within this section</small>
        </div>
        <span>{{ activeGroupViews(group.ownershipType).length }}</span>
      </header>

      <dw-ordered-list class="view-order-list" [items]="activeGroupViews(group.ownershipType)"
        (itemsChange)="onViewsOrdered($event)" (itemRemoved)="onViewRemoved($event)"
        *ngIf="canManageGroup(group.ownershipType); else readOnlyViews">
        <ng-container *dwListItem="let view">
          <div class="ordered-view-content">
            <div class="view-name">
              <strong>{{ view.name }}</strong>
            </div>

            <button type="button" class="default-view" [class.is-default]="view.isDefault"
              [disabled]="view.isDefault" (click)="setDefaultView(view)"
              [title]="view.isDefault ? 'Default view' : 'Make default'">
              <i class="fa" [class.fa-star]="view.isDefault" [class.fa-star-o]="!view.isDefault"></i>
              <span>{{ view.isDefault ? 'Default' : 'Make default' }}</span>
            </button>
          </div>
        </ng-container>
      </dw-ordered-list>

      <ng-template #readOnlyViews>
        <div class="view-list">
          <article class="view-row read-only-view-row"
            *ngFor="let view of activeGroupViews(group.ownershipType); trackBy: trackView">
            <div class="view-name"><strong>{{ view.name }}</strong></div>
            <button type="button" class="default-view" [class.is-default]="view.isDefault"
              [disabled]="view.isDefault" (click)="setDefaultView(view)"
              [title]="view.isDefault ? 'Default view' : 'Make default'">
              <i class="fa" [class.fa-star]="view.isDefault" [class.fa-star-o]="!view.isDefault"></i>
              <span>{{ view.isDefault ? 'Default' : 'Make default' }}</span>
            </button>
          </article>
        </div>
      </ng-template>

      <div class="view-list removed-view-list" *ngIf="removedGroupViews(group.ownershipType).length">
        <article class="view-row pending-removal"
          *ngFor="let view of removedGroupViews(group.ownershipType); trackBy: trackView">
          <div class="view-name">
            <strong>{{ view.name }}</strong>
            <small>Pending removal</small>
          </div>
          <button type="button" class="restore-view" (click)="restoreView(view)">
            <i class="fa fa-undo"></i> Undo
          </button>
        </article>
      </div>
    </section>
  </ng-container>
</div>
